import React from 'react'
import Navbar from '../defaultComponents/Navbar'
import Footer from '../defaultComponents/Footer'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const PageWrapper = styled.div`
  background: #f8f8f8;
`

const AssetBanner = styled.div`
  min-height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`
const AssetPageTitle = styled.div`
  font-size: 2.5vw;
  font-family: Montserrat;
  font-weight: bold;
  width: 75vw;

  display: flex;

  justify-content: space-between;
  align-items: center;

  @media (max-width: 700px) {
    font-size: 1.5rem;
    width: 90vw;
  }
`

const AssetBoxContainer = styled.div`
  border: 1px solid #E3E4E6;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(67,137,162,0.08);
  background: white;
  min-height: 60vh;
  width: 75vw;
  gap: 1vw;
  padding: 2vw 2vw 2vw 2vw;

  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 700px) {
    background: papayawhip;
    grid-template-columns: repeat(1, 1fr);
    width: 90vw;
  }
`

const AssetBox = styled.div`
  border: 1px solid #E3E4E6;
  border-radius: 5px;
  background: white;

  display: flex;
  flex: 0 0 calc(25vw - 2vw);
  height: calc(20vh - 2vw);
  font-family: Inter;
  font-size: 1.5vw;
  cursor: pointer;

  &:hover{
    color: tomato;
    transform: scale(1.05);
  }

  @media (max-width: 700px) {
    font-size: 1.5rem;
    padding: 1vw 0vh 1vw 0vh;
  }
`

const AssetName = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`

const AssetPicture = styled.div`
  background: #F8F8F8;
  min-width: 40%;
`

const AssetInfoBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  padding: 1vh 1vw 1vh 1vw;
`

const LoadMoreBox = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1vh;

  flex-direction: column;
  align-items: center;
  width: 75vw;
`

const LoadMoreButton = styled.button`
  background: tomato;
  font-size: 1.5rem;
  color: white;
  border: none;
  padding: 5px 25px 5px 25px;

  font-weight: bold;

  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background: #d43a00;
  }

  margin-top: 4vh;
`

const LoadCount = styled.div`
`

const testData = [
  {
    "asset_id": "1",
    "asset_name": "Traffic Cone",
    "asset_total_stock": "100",
    "in_stock_quantity": "100"
  },
  {
    "asset_id": "2",
    "asset_name": "Speed Bump",
    "asset_total_stock": "50",
    "in_stock_quantity": "50"
  },
  {
    "asset_id": "3",
    "asset_name": "Barricade",
    "asset_total_stock": "30",
    "in_stock_quantity": "30"
  },
  {
    "asset_id": "4",
    "asset_name": "Road Sign",
    "asset_total_stock": "75",
    "in_stock_quantity": "75"
  },
  {
    "asset_id": "5",
    "asset_name": "Flashing Light",
    "asset_total_stock": "40",
    "in_stock_quantity": "40"
  },
  {
    "asset_id": "6",
    "asset_name": "Parking Block",
    "asset_total_stock": "20",
    "in_stock_quantity": "20"
  },
  {
    "asset_id": "7",
    "asset_name": "Traffic Mirror",
    "asset_total_stock": "10",
    "in_stock_quantity": "10"
  },
  {
    "asset_id": "8",
    "asset_name": "Pavement Marker",
    "asset_total_stock": "200",
    "in_stock_quantity": "200"
  },
  {
    "asset_id": "9",
    "asset_name": "Traffic Barrier",
    "asset_total_stock": "15",
    "in_stock_quantity": "15"
  },
  {
    "asset_id": "10",
    "asset_name": "Pedestrian Crossing Signal",
    "asset_total_stock": "8",
    "in_stock_quantity": "8"
  },
  {
    "asset_id": "11",
    "asset_name": "Radar Speed Sign",
    "asset_total_stock": "25",
    "in_stock_quantity": "25"
  },
  {
    "asset_id": "12",
    "asset_name": "Traffic Drum",
    "asset_total_stock": "35",
    "in_stock_quantity": "35"
  },
  {
    "asset_id": "13",
    "asset_name": "Guardrail",
    "asset_total_stock": "45",
    "in_stock_quantity": "45"
  },
  {
    "asset_id": "14",
    "asset_name": "Traffic Delineator",
    "asset_total_stock": "65",
    "in_stock_quantity": "65"
  },
  {
    "asset_id": "15",
    "asset_name": "Lane Divider",
    "asset_total_stock": "55",
    "in_stock_quantity": "55"
  },
  {
    "asset_id": "16",
    "asset_name": "Roundabout Sign",
    "asset_total_stock": "12",
    "in_stock_quantity": "12"
  },
  {
    "asset_id": "17",
    "asset_name": "Speed Limit Sign",
    "asset_total_stock": "150",
    "in_stock_quantity": "150"
  },
  {
    "asset_id": "18",
    "asset_name": "Traffic Camera",
    "asset_total_stock": "5",
    "in_stock_quantity": "5"
  },
  {
    "asset_id": "19",
    "asset_name": "Stop Sign",
    "asset_total_stock": "100",
    "in_stock_quantity": "100"
  },
  {
    "asset_id": "20",
    "asset_name": "Yield Sign",
    "asset_total_stock": "90",
    "in_stock_quantity": "90"
  }
]

export default function AssetHirePageClient() {

  const navigate = useNavigate()

  const [displayCount, setDisplayCount] = React.useState(9)

  const [showingCount, setShowingCount] = React.useState(9)
  const calculateItemDisplayCount = () =>{
    if (showingCount + 9 >= testData.length) {
      setShowingCount(testData.length)
    } else{
      setShowingCount(displayCount)
    }
  }

  React.useEffect(()=>{
    calculateItemDisplayCount()
  }, [displayCount])
  return (<>
    <Navbar />
    <PageWrapper>
      <AssetBanner>
        <AssetPageTitle>
          <div>Asset Hire</div>
          <ShoppingCartIcon sx={{fontSize:"2vw", color:"tomato", cursor:"pointer"}} onClick={()=>{navigate("/AssetHire/Client/Cart")}}/>
        </AssetPageTitle>
        <AssetBoxContainer>
          {testData.slice(0, displayCount).map((entry, idx) => (
            <AssetBox key={entry.asset_id} onClick={()=>{navigate(`${entry.asset_id}`)}}>
              <AssetPicture></AssetPicture>
              <AssetInfoBox>
                <AssetName>{entry.asset_name}</AssetName>
              </AssetInfoBox>
            </AssetBox>
          ))}
        </AssetBoxContainer>
        <LoadMoreBox>
          <LoadCount>Showing {showingCount} of {testData.length}</LoadCount>
          <LoadMoreButton onClick={()=>{setDisplayCount(prevCount => prevCount + 9)}}>Load More</LoadMoreButton>
        </LoadMoreBox>
      </AssetBanner>
      <Footer />
    </PageWrapper>

  </>)
}
